import { ArrowTrendingUpIcon, CalendarIcon } from "@heroicons/react/20/solid";
import { ReactComponent as Overview } from "../../../../assets/images/account-overview.svg";
import { ReactComponent as Traits } from "../../../../assets/images/account-trait.svg";
import { ReactComponent as Users } from "../../../../assets/images/account-user.svg";
import Tab from "../../../../shared/ui/links/Tab";

type AccountRoutesProps = {
  className?: string;
};

const AccountRoutes = ({ className = '' }: AccountRoutesProps) => (
  <nav className={`flex border-b bg-white gap-3 w-full px-3 ${className}`}>
    <Tab LeadingIcon={Overview} to="overview">Overview</Tab>
    <Tab LeadingIcon={Traits} to="traits">Traits</Tab>
    <Tab LeadingIcon={Users} to="users">Users</Tab>
    <Tab LeadingIcon={ArrowTrendingUpIcon as any} to="trends">Trends</Tab>
    <Tab LeadingIcon={CalendarIcon as any} to="events">Events</Tab>
  </nav>
);

export default AccountRoutes;
